import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import { paths } from "../paths";
import { User } from "../user";

export const CustomMenu = ({ logoutFunc }: { logoutFunc: () => void }) => {
  const location = useLocation();

  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <Menu
        theme="dark"
        mode="horizontal"
        defaultSelectedKeys={[location.pathname]}
      >
        {paths.map((item) => (
          <Menu.Item key={item.path}>
            <Link to={item.path}>{item.text}</Link>
          </Menu.Item>
        ))}
      </Menu>
      <User logoutFunc={logoutFunc} user="user" />
    </div>)
}
